// src/modules/leads/route-planner/RouteStopCard.js
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { StopCard, StopNumber, StopInfo, StopName, StopAddress, StopMeta } from './routePlannerStyles';
import { ActionButton } from './routePlannerStyles';
import { MARKER_COLORS } from './routeUtils';
import OriginBadge from '../../../components/shared/OriginBadge';

const RouteStopCard = ({ lead, index, legInfo, onRemove }) => {
  const address = [lead.street, lead.city, lead.state, lead.zipcode].filter(Boolean).join(', ');

  return (
    <StopCard>
      <StopNumber color={MARKER_COLORS.waypoint}>
        {index + 1}
      </StopNumber>
      <StopInfo>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', minWidth: 0 }}>
          <StopName>{lead.name}</StopName>
          {lead.origin?.origin_name && (
            <OriginBadge origin={lead.origin} size="sm" />
          )}
        </div>
        <StopAddress>{address}</StopAddress>
        {legInfo && (
          <StopMeta>
            {legInfo.distance} &middot; {legInfo.duration}
          </StopMeta>
        )}
      </StopInfo>
      <ActionButton
        variant="danger"
        onClick={() => onRemove?.(lead.id)}
        title="Remove from route"
      >
        <FaTimes />
      </ActionButton>
    </StopCard>
  );
};

export default RouteStopCard;
